:host {
  display: block;
  /** @prop --container-width-max: Set the maximum width of the page content. */
  --container-width-max: 1312px;

  /** @prop --container-margin-xs: Set the margin of the container at the smallest screen size. */
  --container-margin-xs: var(--p-size-static-200);

  /** @prop --container-margin-sm: Set the margin of the container at the small screen size. */
  --container-margin-sm: var(--p-size-static-400);

  /** @prop --container-margin-md: Set the margin of the container at the medium screen size. */
  --container-margin-md: var(--p-size-static-800);

  /** @prop --container-margin-lg: Set the margin of the container at the large screen size. */
  --container-margin-lg: var(--p-size-static-800);

  /** @prop --container-margin-xl: Set the margin of the container at the extra large screen size. */
  --container-margin-xl: var(--p-size-static-800);
}

.anchor-c-container {
  display: flex;
  --container-margin: var(--container-margin-xs);
  width: calc(100% - (var(--container-margin) * 2));
  max-width: var(--container-width-max);
  margin: 0 var(--container-margin);
  @media (max-width: 599px) {
    --container-margin: var(--container-margin-xs);
  }
  @media (min-width: 600px) and (max-width: 904px) {
    --container-margin: var(--container-margin-sm);
  }
  @media (min-width: 905px) and (max-width: 1239px) {
    --container-margin: var(--container-margin-md);
  }
  @media (min-width: 1240px) and (max-width: 1439px) {
    --container-margin: var(--container-margin-lg);
  }
  @media (min-width: 1440px) {
    --container-margin: var(--container-margin-xl);
    width: 100%;
    margin: 0 auto;
  }
}
